<template>
    <IconBase  v-bind="$props" v-on="$listeners">
    <path
        d="M26.25 4.6875V2.8125C24.3862 2.8125 22.9312 3.33281 21.9328 4.35C21.438 4.85992 21.0714 5.48006 20.8631 6.15938C20.3869 5.83125 19.8337 5.625 19.2187 5.625C16.8534 5.625 15.9591 7.5075 15.9375 8.78906C15.937 9.00423 15.9298 9.21934 15.9159 9.43406C15.2859 11.2969 14.0625 10.0622 14.0625 7.5C11.0409 10.7081 14.2969 11.8912 12.4406 13.7475C12.045 14.1431 11.1 14.2969 10.5094 13.5722C9.73031 12.645 11.3156 11.1216 9.81469 9.9825C10.0894 11.6972 8.7675 11.3419 8.32031 10.9753C7.73812 10.4991 6.67969 9.45188 8.4375 6.5625C6.63937 7.38281 5.55562 9.04875 5.625 10.3125C5.8125 13.6266 10.935 16.5047 8.86594 18.4387C7.8225 19.4166 5.77219 18.0947 6.5625 15.9375C5.57812 16.4391 4.42031 17.6334 4.79062 19.4906C5.04562 20.775 6.91312 23.6719 3.75 25.3125L3.79031 25.3237L3.70969 27.1875C3.77156 27.1912 4.02469 27.1987 4.43156 27.1987C7.06781 27.1987 16.1934 26.7919 21.8119 21.4125C24.7556 18.5925 26.25 14.8575 26.25 10.3125C26.25 9.01594 25.6603 6.5625 23.4375 6.5625C23.1628 6.5625 22.9069 6.6 22.665 6.65813C22.7709 6.34313 22.9537 5.98312 23.2687 5.66156C23.9062 5.0175 24.9056 4.6875 26.25 4.6875ZM23.4375 8.4375C24.3234 8.4375 24.375 10.2975 24.375 10.3125C24.375 14.3222 23.0747 17.5997 20.5191 20.0531C16.3697 24.0309 9.8325 25.0163 6.28406 25.2506C7.14844 25.0528 8.18812 24.6497 9.32719 23.8809C14.8134 20.8744 17.6991 13.7841 17.805 9.06375H17.8125V8.80781C17.8162 8.5875 17.9044 7.5 19.2187 7.5C20.0203 7.5 20.625 8.63906 20.625 9.375H22.5C22.5 8.97188 22.5984 8.4375 23.4375 8.4375Z"
        fill="#656565" />
    </IconBase>
</template>

<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
  components: { IconBase },
  props: {
    ...iconProps,
    height: {
        ...iconProps.height,
        default: 30,
    },
    width: {
        ...iconProps.width,
        default: 30,
    },
    viewBox: {
        ...iconProps.viewBox,
        default: "0 0 30 30",
    }
  },
}
</script>